// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3cMDc","info":"UpdateTermsInfo_info__2dZCU"};